import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-toasts',
  standalone: true,
  template: `
    <!-- Placeholder for toast portal, replace with @ngneat/hot-toast or similar -->
    <div class="fixed bottom-4 right-4 space-y-2 z-50"></div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastsComponent {}


